import { Stack, Box, Typography } from "@mui/material";

const ModuleLegendItem = ({
  label,
  color,
  outline = false,
}: {
  label: string;
  color: string;
  outline?: boolean;
}) => {
  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Box
        sx={{
          height: "8px",
          width: "8px",
          borderRadius: "3px",
          bgcolor: outline ? "white" : color,
          border: outline ? "1px solid" : "none",
          borderColor: outline ? color : undefined,
        }}
      />
      <Typography
        variant="bodySecondaryReg"
        sx={{ color: "shades.neutral.600" }}
      >
        {label}
      </Typography>
    </Stack>
  );
};

export default ModuleLegendItem;
